import React, { useState, useEffect } from 'react';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import FileCopy from '@material-ui/icons/FileCopy';
import IndeterminateCheckBoxOutlinedIcon from '@material-ui/icons/IndeterminateCheckBoxOutlined';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { StylesProvider, makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

const useStyles = makeStyles((theme) => ({
    pasteButton: {
        fontSize: "0.8rem !important",
        marginTop: "0 !important",
        textTransform: "none !important",
        paddingLeft: "4px !important"
    }
}));

const TranscriptButton = (props) => {
    const classes = useStyles();
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [hidden, setHidden] = useState(props?.hidden ?? true)
    const [pasteHover, setPasteHover] = useState(false)
    const [hashName, setHashName] = useState(props?.hashName ?? '');

    useEffect(() => {
        console.log(window.location.hash);
        if (hashName != '') {
            if (window.location.hash.toLowerCase() == '#' + hashName) {
                setHidden(false);
            } else {
                if (props?.hidden !== false)
                    setHidden(true);
            }
        }
    }, [window.location.hash, hashName]);

    const handleTranscript = () => {
        setHidden(!hidden);
    }
    useEffect(() => {
        if (!props?.contentblock)
            return;
        if (hidden) {
            props.contentblock.style.display = 'none';

        } else {
            props.contentblock.style.display = 'block';
            if(props.big)
                props.contentblock.setAttribute("data-big", "");
        }
        if (pasteHover) {
            props.contentblock.style.border = "2px dashed rgb(153, 153, 153)";

        } else {
            props.contentblock.style.border = '2px solid transparent';

        }
    }, [hidden, pasteHover]);
    useEffect(() => {
        if (!props?.contentblock)
            return;
        props.contentblock.classList.toggle("pastable", props.paste);
    }, [props.paste]);

    function copyFormatted(html) {
        var container = document.createElement('div')
        container.innerHTML = html
        container.style.position = 'fixed'
        container.style.pointerEvents = 'none'
        container.style.opacity = 0
        var activeSheets = Array.prototype.slice.call(document.styleSheets)
            .filter(function (sheet) {
                return !sheet.disabled
            })
        document.body.appendChild(container)
        window.getSelection().removeAllRanges()
        var range = document.createRange()
        range.selectNode(container)
        window.getSelection().addRange(range)
        document.execCommand('copy')
        for (var i = 0; i < activeSheets.length; i++)
            activeSheets[i].disabled = true
        document.execCommand('copy')
        for (var i = 0; i < activeSheets.length; i++)
            activeSheets[i].disabled = false
        document.body.removeChild(container)
    }

    const handleCopy = () => {
        if (!props?.contentblock)
            return;
        copyFormatted(props.contentblock.innerHTML);
        setSaveSuccess(true);

    }; const handleSuccessClose = function () {
        setSaveSuccess(false);
    };
    return (
        <StylesProvider injectFirst>
            <React.Fragment>
                <Button className='transcript-accordion'
                    data-open={hidden ? '0' : '1'}
                    aria-label={hidden ? 'Show hidden section' : 'Hide section'}
                    onClick={handleTranscript}
                    disableRipple={true}
                    color="primary"
                    endIcon={<div>{hidden ? <AddBoxOutlinedIcon className="noprint" /> : <IndeterminateCheckBoxOutlinedIcon className="noprint" />}<IndeterminateCheckBoxOutlinedIcon className="printonly" /></div>}>
                    {props.big ? "" : (hidden ? 'Show' : 'Hide')} {props?.label ?? "transcript"}
                </Button>
                {props.paste && !hidden ? <Tooltip title="copy contents to clipboard">
                    <Button onClick={handleCopy} color="primary" startIcon={<FileCopy />} className={classes.pasteButton}
                        onMouseOver={() => setPasteHover(true)} onMouseLeave={() => setPasteHover(false)}> Copy to clipboard</Button>
                </Tooltip> : null}
                <Snackbar open={saveSuccess} autoHideDuration={6000} onClose={handleSuccessClose}>
                    <Alert onClose={handleSuccessClose} severity="success" elevation={2}> Copied to clipboard </Alert>
                </Snackbar>
            </React.Fragment>
        </StylesProvider>
    );
};

export default TranscriptButton;